enum DropdownFieldActionType {
    DISPLAY_DROPDOWN_FIELD_ERROR = "DISPLAY_DROPDOWN_FIELD_ERROR",
    UPDATE_DROPDOWN_FIELD_VALUE = "UPDATE_DROPDOWN_FIELD_VALUE",
    RESET_DROPDOWN_FIELD = "RESET_DROPDOWN_FIELD",
}

export default DropdownFieldActionType;
